import { TierFilter } from './tier-filter';
import { Tierreklamation } from '../../../classes/tierreklamation';
import { TierGeschlecht } from '../../../classes/tier-geschlecht';
import { TierRasse } from '../../../classes/tier-rasse';
import { Tierliste } from '../../../classes/tierliste';
import { HttpParams } from '@angular/common/http';
import { Haendler } from '../../../../stammdaten/haendler/haendler';
import { formatDate } from '@angular/common';
import { Abteil } from '../../gruppe-tier-abteil-filter/gruppe-tier-abteil-filter';
import { GruppeTierEinstalldatum } from '../../../../../components/gruppe-tier/filter/gruppe-tier-einstalldatum-filter/gruppe-tier-einstalldatum';
import { Betriebskontakt } from '../../../../stammdaten/betriebskontakte/betriebskontakt';
import { HerkunftsbetriebFilter } from '../../gruppe-tier-herkunft-filter/gruppe-tier-herkunft-filter';

export class TierFilterSettings {
    abteile: Abteil[] = [];
    reklamationen: Tierreklamation[] = [];
    geschlechter: TierGeschlecht[] = [];
    rassen: TierRasse[] = [];
    filter: TierFilter = TierFilter.ALLE_TIERE;
    abgangslisten: Tierliste[] = [];
    viehhaendler: Haendler[] = [];
    betriebskontakte: Betriebskontakt[] = [];
    einstalldatum: GruppeTierEinstalldatum[] = [];
    herkunftsbetriebe: HerkunftsbetriebFilter[] = [];

    showAbteile = true;
    showReklamationen = true;
    showGeschlechter = true;
    showRassen = true;
    showFilter = true;
    showAbgangslisten = true;
    showViehhaendler = true;
    showEinstalldatum = true;
    showBetriebskontakte = false;
    showHerkunftsbetriebe = true;

    clone(): TierFilterSettings {
        const tfs = new TierFilterSettings();
        tfs.abteile = [...(this.abteile || [])];
        tfs.reklamationen = [...(this.reklamationen || [])];
        tfs.geschlechter = [...(this.geschlechter || [])];
        tfs.rassen = [...(this.rassen || [])];
        tfs.filter = this.filter ?? TierFilter.ALLE_TIERE;
        tfs.abgangslisten = [...(this.abgangslisten || [])];
        tfs.viehhaendler = [...(this.viehhaendler || [])];
        tfs.betriebskontakte = [...(this.betriebskontakte || [])];
        tfs.einstalldatum = [...(this.einstalldatum || [])];
        tfs.herkunftsbetriebe = [...(this.herkunftsbetriebe || [])];

        tfs.showAbteile = this.showAbteile;
        tfs.showReklamationen = this.showReklamationen;
        tfs.showGeschlechter = this.showGeschlechter;
        tfs.showRassen = this.showRassen;
        tfs.showFilter = this.showFilter;
        tfs.showAbgangslisten = this.showAbgangslisten;
        tfs.showViehhaendler = this.showViehhaendler;
        tfs.showEinstalldatum = this.showEinstalldatum;
        tfs.showBetriebskontakte = this.showBetriebskontakte;
        tfs.showHerkunftsbetriebe = this.showHerkunftsbetriebe;

        return tfs;
    }

    /** Normalize cleared controls (undefined / null) before apply/persist. */
    normalize(): TierFilterSettings {
        this.abteile = this.abteile || [];
        this.reklamationen = this.reklamationen || [];
        this.geschlechter = this.geschlechter || [];
        this.rassen = this.rassen || [];
        this.abgangslisten = this.abgangslisten || [];
        this.viehhaendler = this.viehhaendler || [];
        this.betriebskontakte = this.betriebskontakte || [];
        this.einstalldatum = this.einstalldatum || [];
        this.herkunftsbetriebe = this.herkunftsbetriebe || [];
        if (!this.filter || this.filter.key == null) {
            this.filter = TierFilter.ALLE_TIERE;
        }
        return this;
    }

    isFilterActive() {
        if (this.abteile?.length > 0) {
            return true;
        }
        if (this.reklamationen?.length > 0) {
            return true;
        }
        if (this.geschlechter?.length > 0) {
            return true;
        }
        if (this.rassen?.length > 0) {
            return true;
        }
        if (this.abgangslisten?.length > 0) {
            return true;
        }
        if (this.viehhaendler?.length > 0) {
            return true;
        }
        if (this.betriebskontakte?.length > 0) {
            return true;
        }
        if (this.einstalldatum?.length > 0) {
            return true;
        }
        if (this.herkunftsbetriebe?.length > 0) {
            return true;
        }
        if (this.filter?.key != null) {
            return true;
        }
        return false;
    }

    getAsParams(): HttpParams {
        let params = new HttpParams();

        if (this.abteile && this.showAbteile) {
            this.abteile.forEach(abteil => {
                params = params.append('abteil[]', abteil.abteil);
            });
        }

        if (this.reklamationen && this.showReklamationen) {
            this.reklamationen.forEach(reklamation => {
                params = params.append('tierreklamation_id[]', reklamation.tierreklamation_id);
            });
        }

        if (this.geschlechter && this.showGeschlechter) {
            this.geschlechter.forEach(geschlecht => {
                params = params.append('geschlecht_id[]', geschlecht.geschlecht_id);
            });
        }

        if (this.rassen && this.showRassen) {
            this.rassen.forEach(rasse => {
                params = params.append('rasse_id[]', rasse.rasse_id);
            });
        }

        if (this.abgangslisten && this.showAbgangslisten) {
            this.abgangslisten.forEach(liste => {
                params = params.append('tierliste_id[]', liste.tierliste_id);
            });
        }

        if (this.viehhaendler && this.showViehhaendler) {
            this.viehhaendler.forEach(liste => {
                params = params.append('viehhaendler_id[]', liste.viehhaendler_id);
            });
        }

        if (this.filter?.key != null && this.showFilter) {
            params = params.set(this.filter.key, this.filter.value);
        }

        if (this.betriebskontakte && this.showBetriebskontakte) {
            this.betriebskontakte.forEach(kontakt => {
                params = params.append('betriebskontakt_haendler_id[]', kontakt.kunde_id.toString());
            });
        }

        if (this.einstalldatum && this.showEinstalldatum) {
            this.einstalldatum.forEach(datum => {
                params = params.append('einstalldatum[]', formatDate(datum?.einstalldatum, 'yyyy-MM-dd', 'de'));
            });
        }

        if (this.herkunftsbetriebe && this.showHerkunftsbetriebe) {
            this.herkunftsbetriebe.forEach(herkunft => {
                params = params.append('herkunft_kunde_id[]', herkunft.herkunft_kunde_id.toString());
            });
        }

        return params;
    }

    /** Human-readable filter lines for PDF header (one entry per active filter). */
    getFilterLabels(): string[] {
        const labels: string[] = [];

        if (this.filter?.key != null && this.showFilter) {
            labels.push(this.filter.name);
        }

        if (this.abteile?.length > 0 && this.showAbteile) {
            labels.push('Abteil: ' + this.abteile.map(a => a.abteil).filter(Boolean).join(', '));
        }

        if (this.abgangslisten?.length > 0 && this.showAbgangslisten) {
            const names = this.abgangslisten
                .map(l => l.kunde_einstallen || l.kommentar || String(l.tierliste_id))
                .filter(Boolean);
            if (names.length > 0) {
                labels.push('Abgangsliste: ' + names.join(', '));
            }
        }

        if (this.reklamationen?.length > 0 && this.showReklamationen) {
            const names = this.reklamationen.map(r => r.reklamation).filter(Boolean);
            if (names.length > 0) {
                labels.push('Reklamation: ' + names.join(', '));
            }
        }

        if (this.rassen?.length > 0 && this.showRassen) {
            const names = this.rassen.map(r => r.name || r.kuerzel).filter(Boolean);
            if (names.length > 0) {
                labels.push('Rasse: ' + names.join(', '));
            }
        }

        if (this.geschlechter?.length > 0 && this.showGeschlechter) {
            const names = this.geschlechter.map(g => g.bezeichnung).filter(Boolean);
            if (names.length > 0) {
                labels.push('Geschlecht: ' + names.join(', '));
            }
        }

        if (this.viehhaendler?.length > 0 && this.showViehhaendler) {
            const names = this.viehhaendler.map(h => h.name).filter(Boolean);
            if (names.length > 0) {
                labels.push('Händler: ' + names.join(', '));
            }
        }

        if (this.betriebskontakte?.length > 0 && this.showBetriebskontakte) {
            const names = this.betriebskontakte
                .map(k => k.bezeichnung_final || k.bezeichnung)
                .filter(Boolean);
            if (names.length > 0) {
                labels.push('Betriebskontakt: ' + names.join(', '));
            }
        }

        if (this.herkunftsbetriebe?.length > 0 && this.showHerkunftsbetriebe) {
            const names = this.herkunftsbetriebe
                .map(h => {
                    const name = (h.herkunft_betrieb || '').trim() || 'Unbekannt';
                    const vvvo = (h.herkunft_vvvo || '').trim();
                    return vvvo ? `${name} (${vvvo})` : name;
                })
                .filter(Boolean);
            if (names.length > 0) {
                labels.push('Herkunftsbetrieb: ' + names.join(', '));
            }
        }

        if (this.einstalldatum?.length > 0 && this.showEinstalldatum) {
            const dates = this.einstalldatum
                .map(d => (d?.einstalldatum ? formatDate(d.einstalldatum, 'dd.MM.yyyy', 'de') : null))
                .filter(Boolean);
            if (dates.length > 0) {
                labels.push('Einstalldatum: ' + dates.join(', '));
            }
        }

        return labels;
    }
}
